import React, { useState } from 'react';
import { TextField, InputAdornment } from '@mui/material';
import GridPicker from './GridPicker';

// Uniform picker field: looks like a normal field; click opens a searchable, sortable grid.
// options: [{ value, label, ...extra columns }]   columns: see GridPicker
export default function GridSelect({ label, value, options, columns, onChange, placeholder, emptyText, error, helperText, disabled }) {
    const [open, setOpen] = useState(false);
    const sel = (options || []).find((o) => o.value === value);
    return (
        <div>
            <TextField
                label={label}
                value={sel ? sel.label : value || ''}
                fullWidth
                error={error}
                helperText={helperText}
                disabled={disabled}
                onClick={() => { if (!disabled) setOpen(!open); }}
                InputProps={{
                    readOnly: true,
                    style: { cursor: disabled ? 'default' : 'pointer' },
                    endAdornment: (
                        <InputAdornment position="end">
                            <i className="fas fa-th-list" style={{ color: '#6c757d', cursor: 'pointer' }}></i>
                        </InputAdornment>
                    )
                }}
                inputProps={{ style: { cursor: disabled ? 'default' : 'pointer' } }}
            />
            {open && (
                <GridPicker
                    rows={options}
                    columns={columns || [{ key: 'label', label: 'Name', bold: true }]}
                    selectedValue={value}
                    placeholder={placeholder}
                    emptyText={emptyText}
                    onClose={() => setOpen(false)}
                    onSelect={(r) => { onChange(r.value, r); setOpen(false); }}
                />
            )}
        </div>
    );
}
